import { clearScoreboardConfig } from '../../utils/scoreboard';

angular.module('app.directives.schedule').directive('broadcastOverlayConfiguration', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    template: require('./broadcast-overlay-configuration.html'),
    controller: controller,
  };
});

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    let html = `<div class="${wrapperCssClass}" style="vertical-align: middle;">`;
    html += `<div style="display: inline-flex; float: left; width: 32px; height: 32px; margin-right: 6px;">`;
    if (item.value.type == 'scoreboard') {
      html += '<img src="/img/sports/scoreboard_icon.svg">';
    } else if (item.value.type == 'overlay') {
      html += '<img src="/img/sports/overlay_icon.svg">';
    }
    html += `</div>`;
    html += `<div class="overflow-ellipse" style="line-height:32px;">${item.name}</div></div>`;
    return html;
  };
}

export function controller($scope, $timeout) {
  'ngInject';

  const { vm } = $scope;

  // Use `sc` as a shortcut in controller and template
  $scope.sc = vm.service.broadcast.scoreboard_configuration;

  $scope.canDoOverlays =
    vm.service.FeatureFlags.overlays &&
    vm.service.user.can('update', 'broadcast/*:metadata/overlays');
  $scope.options = {
    dropdown: [],
    selected: null,
    showScoreboardConfiguration: !!$scope.sc.sport,
    showOverlayConfiguration: !!(vm.service.broadcast.metadata.overlays || []).length,
  };

  if (vm.service.showAnyScoreboards) {
    $scope.options.dropdown.push({
      name: 'Manual or Automatic Scoring',
      value: { type: 'scoreboard' },
    });
    $scope.options.dropdown.forEach((a) => (a.valueJson = JSON.stringify(a.value)));
  }
  $scope.$watch(
    () => vm.service.allowDefaultOverlay && vm.overlays && vm.overlays.length > 0,
    (allowed) => {
      if (allowed) {
        $scope.options.dropdown.push({
          name: 'Default Graphic Overlay (e.g. Logo or Branding)',
          value: { type: 'overlay' },
        });
        $scope.options.dropdown.forEach((a) => (a.valueJson = JSON.stringify(a.value)));
      }
    }
  );

  const selectizeConfigBase = {
    valueField: 'valueJson',
    labelField: 'name',
    highlight: true,
    searchField: 'name',
    selectOnTab: true,
    closeAfterSelect: true,
    maxItems: 1,
    render: {
      option: renderSelectizeOption('source-chooser--option'),
      item: renderSelectizeOption('source-chooser--selected'),
    },
    onInitialize: (selectize) => {
      $scope.selectize = selectize;
    },
    onChange: (value) => {
      if (!value) return;
      value = JSON.parse(value);
      $timeout(() => {
        if (value.type == 'scoreboard') {
          $scope.options.showScoreboardConfiguration = true;
        } else if (value.type == 'overlay') {
          $scope.options.showOverlayConfiguration = true;
        } else {
          console.warn('invalid item selected: ', value);
        }
      }, 0);
      $scope.selectize.clear();
      $timeout(() => {
        $scope.options.selected = null;
      }, 500);
    },
  };
  $scope.selectizeConfig = angular.extend(
    { placeholder: 'Select Scoreboard and/or Graphic Overlay...' },
    selectizeConfigBase
  );

  $scope.clearScoreboardConfig = function () {
    clearScoreboardConfig($scope.sc);
    $scope.options.showScoreboardConfiguration = false;
  };

  $scope.clearOverlayConfig = function () {
    delete vm.service.broadcast.metadata.overlays;
    $scope.options.showOverlayConfiguration = false;
  };
}



// WEBPACK FOOTER //
// ./app/directives/schedule/broadcast-overlay-configuration.js